let GoogleReCaptchaURL;
const RECAPTCHA_V2 = window.config.RECAPTCHA_V2;

function GoogleCaptchaService($q, resourceInjector, settingsService, Restangular) {
    this._api = Restangular.one('ValidateGoogleCaptcha');
    this.resourceInjector = resourceInjector;
    this.$q = $q;
    this.settingsService = settingsService;
    this.settingsService.getSettingValue('GoogleReCaptcha', 'GoogleReCaptchaURL').then(function (setting) {
         GoogleReCaptchaURL = setting;
    });
}

GoogleCaptchaService.prototype.loadReCaptcha = function () {
    const deferred = this.$q.defer();
    const recaptchaEleId = 'g-recaptcha';

    if (this.resourceInjector.isScriptInjected(GoogleReCaptchaURL)) {
        if (window.grecaptcha) {
            window.grecaptcha.render(recaptchaEleId,{'sitekey':RECAPTCHA_V2});
        } else {
            this.resourceInjector.removeHeadSrcInjection(GoogleReCaptchaURL);
            this.resourceInjector.injectScript(GoogleReCaptchaURL);
        }
    } else {
        this.resourceInjector.injectScript(GoogleReCaptchaURL);
    }


    deferred.resolve(window.grecaptcha);

    return deferred.promise;
};

GoogleCaptchaService.prototype.validategooglecaptcha = function (args) {
    const deferred = this.$q.defer();
    this._api.doPOST(args).then(function (captchaResponse) {
        deferred.resolve(captchaResponse);
    });
    return deferred.promise;
};

module.exports = GoogleCaptchaService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/googlecaptcha/googlecaptcha-service.js
 **/